import React from "react";
import PropTypes from "prop-types";
import "../style.css";

/**
 * ChatWrapper - Layout container for Chat screen.
 * Ensures ChatHeader is always visible, ChatHistory is flexible,
 * and ChatActions is always at the bottom (above keyboard on mobile).
 *
 * @param {object} props
 * @param {React.ReactNode} props.header - ChatHeader component
 * @param {React.ReactNode} props.history - ChatHistory component
 * @param {React.ReactNode} props.actions - ChatActions component
 * @param {React.ReactNode} [props.journey] - ChatJourney component (optional)
 * @returns {JSX.Element}
 */
export const ChatWrapper = ({ header, history, actions, journey }) => {
  return (
    <div className="chat-main-wrapper">
      <div className="chat-header-fixed">{header}</div>
      <div className="chat-history-flex">
        {history}
        {journey ? <div className="chat-journey-overlay">{journey}</div> : null}
      </div>
      {!journey && <div className="chat-actions-fixed">{actions}</div>}
    </div>
  );
};

ChatWrapper.propTypes = {
  header: PropTypes.node.isRequired,
  history: PropTypes.node.isRequired,
  actions: PropTypes.node.isRequired,
  journey: PropTypes.node,
};

// --- CSS (in ../style.css or a new ChatWrapper.css if needed) ---
// .chat-main-wrapper {
//   display: flex;
//   flex-direction: column;
//   height: 100dvh;
//   width: 100vw;
//   max-width: 100%;
//   max-height: 100%;
//   position: relative;
//   background: #fff;
// }
// .chat-header-fixed {
//   flex: 0 0 auto;
//   z-index: 2;
// }
// .chat-history-flex {
//   flex: 1 1 0%;
//   min-height: 0;
//   overflow-y: auto;
//   position: relative;
//   z-index: 1;
//   display: flex;
//   flex-direction: column;
// }
// .chat-actions-fixed {
//   flex: 0 0 auto;
//   z-index: 3;
//   position: sticky;
//   bottom: 0;
//   background: #fff;
// }
// .chat-journey-overlay {
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   z-index: 10;
// }
